// Navigation items
export const NAV_ITEMS = [
  { href: "/", label: "Home" },
  { href: "/about", label: "About" },
  { href: "/experiences", label: "Experiences" },
  { href: "/dining", label: "Dining" },
  { href: "/events", label: "Events" },
  { href: "/sustainability", label: "Sustainability" },
  { href: "/policies", label: "Policies" },
];

export default NAV_ITEMS;
